export type CanvasTransientGeometryModel = {
  id: string;
  transientXYWH?: string;
};

export type CanvasTransientGeometryEffects = {
  emitUpdated: (model: CanvasTransientGeometryModel) => void;
  refreshBlockHost: () => void;
  requestRender: () => void;
};

export function syncAutoMeasuredTransientXYWH({
  model,
  nextXYWH,
  ownedXYWH,
  effects,
}: {
  model: CanvasTransientGeometryModel;
  nextXYWH: string | null;
  ownedXYWH: string | null;
  effects: CanvasTransientGeometryEffects;
}): string | null {
  if (!nextXYWH) {
    if (ownedXYWH && model.transientXYWH === ownedXYWH) {
      model.transientXYWH = undefined;
      effects.refreshBlockHost();
      effects.emitUpdated(model);
      effects.requestRender();
    }
    return null;
  }

  const currentXYWH = model.transientXYWH;
  if (currentXYWH === nextXYWH) return nextXYWH;
  if (currentXYWH && currentXYWH !== ownedXYWH) return nextXYWH;

  model.transientXYWH = nextXYWH;
  effects.refreshBlockHost();
  effects.emitUpdated(model);
  effects.requestRender();
  return nextXYWH;
}
